var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[(_vm.isEnterMode)?[_c('pattern-card',{attrs:{"pattern":_vm.pattern,"patternLogo":_vm.patternLogo,"fields":_vm.patternFields}})]:[(_vm.isIndividual!==true)?[_c('FilterCard')]:_vm._e()]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }